import React, { memo } from 'react';
import PropTypes from 'prop-types';
import secondsToTime from 'utils/secondsToTime';
import { Text } from 'components';
import {
  TimeBarStyled,
  Wrapper,
  StyledText,
  StyledSlashText,
  StyledAirIcon,
} from './styles/TimeBarStyled';

const secondsPrefix = '00:00:';
const minutesPrefix = '00:';

const TimeBar = ({ position, duration, isLiveDvr, isTimeshift, onClick }) => (
  <TimeBarStyled onClick={isLiveDvr ? onClick : undefined} isTimeshift={isTimeshift}>
    <Wrapper>
      <Text color="white" size="fs_xxs">
        {secondsToTime(position, secondsPrefix, minutesPrefix)}
      </Text>
      <StyledSlashText size="fs_xxs"> / </StyledSlashText>
      {isLiveDvr && <StyledAirIcon isTimeshift={isTimeshift} />}
      <StyledText size="fs_xxs">{secondsToTime(duration, secondsPrefix, minutesPrefix)}</StyledText>
    </Wrapper>
  </TimeBarStyled>
);

TimeBar.propTypes = {
  position: PropTypes.number,
  duration: PropTypes.number,
  isLiveDvr: PropTypes.bool,
  isTimeshift: PropTypes.bool,
  onClick: PropTypes.func,
};

TimeBar.defaultProps = {
  position: 0,
  duration: 0,
  isLiveDvr: false,
  isTimeshift: false,
  onClick: Function.prototype,
};

export default memo(TimeBar);
